import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncMainOrganisations({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/MainOrganisations"));
  console.log("Loading", AsyncMainOrganisations.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncMainOrganisations;
